import { Timer } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import { formatTimeSpan } from '@/lib/formatters'
import { useCustomerTimeToQuoting } from '@/models/insuranceApplication'

/** The customer's time on the page before their first priced quote, or so far while they're still onboarding. */
export function TimeToQuotingPill({ orgId }: { orgId: string }) {
  const { data: summary } = useCustomerTimeToQuoting(orgId)
  if (!summary) return null

  const onPage = formatTimeSpan(summary.timeOnPageSeconds)
  const elapsed = formatTimeSpan(summary.elapsedSeconds)
  return (
    <Badge variant="secondary" className="h-7 rounded-sm">
      <Timer className="size-3.5" />
      {summary.quotesSeenAt
        ? `Time to quoting: ${onPage} on page · ${elapsed} elapsed`
        : `Time to quoting: ${onPage} on page so far · ${elapsed} elapsed`}
    </Badge>
  )
}
